var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9425 7.125H11.75V3.375C11.75 2.9625 11.4125 2.625 11 2.625H8C7.5875 2.625 7.25 2.9625 7.25 3.375V7.125H6.0575C5.39 7.125 5.0525 7.935 5.525 8.4075L8.9675 11.85C9.26 12.1425 9.7325 12.1425 10.025 11.85L13.4675 8.4075C13.94 7.935 13.61 7.125 12.9425 7.125ZM4.25 14.625C4.25 15.0375 4.5875 15.375 5 15.375H14C14.4125 15.375 14.75 15.0375 14.75 14.625C14.75 14.2125 14.4125 13.875 14 13.875H5C4.5875 13.875 4.25 14.2125 4.25 14.625Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.57da0c4ef0ad612a8734f3f4c932d1a4.svg";
export { ForwardRef as ReactComponent };